import { useState, useEffect } from "react";
import Styleclasses from "./style.module.css";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { getFromLocalStorage } from "Utils/Util";
import {
    BasicInfo_PersonalInfo_ADD,
    BasicInfo_PersonalInfo,
} from "Services/Requests";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import Load from "Components/Loader/loader";
import { useStore } from "Store";
import DatePicker from "react-date-picker";

interface Inputs {
    filing_status: string;
    last_name: string;
    middle_name: string;
    // citizenship:string;
    first_name: string;
    ssn: string;
    email: string;
    dob: Date | null;
    occupation: string;
    date_of_marriage: Date | null;
    first_date_of_entry_in_US: Date | null;
    type_of_visa: string;
    tax_file_year_id: number;
    citizenship: string;
    did_you_work_more_than_one_employer_in_XX: number;
    more_than_one_employer_work_status_comments: string;
    timezone: string;
    address: string;
    city: string;
    apt_no: string;
    india_number: string;
    state: string;
    zip: string;
    country: string;
    mobile_phone: string;
    alternate_phone: string;
    spouse_last_name?: string;
    spouse_middle_name?: string;
    spouse_first_name?: string;
    spouse_dob?: Date | null;
    spouse_ssn_or_itin: string;
    spouse_check_if_ITIN_to_be_applied?: number;
    spouse_check_if_ITIN_to_be_renewed?: number;
    spouse_itin_renewed?: number;
    spouse_entry_date_into_US?: Date | null;
    spouse_occupation?: string;
    spouse_did_your_spouse_is_worked_in_XX?: number;
    spouse_is_living_more_than_6months?: string;
    spouse_work_status_comments?: string;
    spouse_did_you_work_more_than_one_employer_in_XX?: number;
    spouse_more_than_one_employer_work_status_comments?: string;
    spouse_type_of_visa?: string;
    // spouse_ssn_or_itin:number;
}

function PersonalInfo() {
    const { isDisabled, SelectedYear } = useStore((state: any) => state);
    // console.log(isDisabled);
    const [loading, setLoading] = useState(false);
    const [isChecked, setIschecked] = useState(false);
    const [userDetails] = useState<any>(getFromLocalStorage("UserDetails"));
    // const pastYear = moment().subtract(1, "years").year();
    const [submit, setSubmit] = useState(false);
    const [currentYears, setCurrentYears] = useState([
        {
            year: SelectedYear,
            stateOfResidence: "",
            From: null,
            To: null,
            id: uuidv4(),
            AddStatus: 1,
            residency_id: 0,
            type_of_residency_details: "basic",
        },
    ]);
    const [Past, setPastYears] = useState([
        {
            year: Number(SelectedYear) - 1,
            stateOfResidence: "",
            From: null,
            To: null,
            id: uuidv4(),
            AddStatus: 1,
            residency_id: 0,
            type_of_residency_details: "basic",
        },
    ]);
    const [currentYears_spouse, setCurrentYears_spouse] = useState([
        {
            year: SelectedYear,
            stateOfResidence: "",
            From: null,
            To: null,
            id: uuidv4(),
            AddStatus: 1,
            residency_id: 0,
            type_of_residency_details: "spouse",
        },
    ]);
    const [Past_spouse, setPastYears_spouse] = useState([
        {
            year: Number(SelectedYear) - 1,
            stateOfResidence: "",
            From: null,
            To: null,
            id: uuidv4(),
            AddStatus: 1,
            residency_id: 0,
            type_of_residency_details: "spouse",
        },
    ]);
    const [oldData, setOldData] = useState<any>([]);
    const [oldDataSpouse, setOldDataSpouse] = useState<any>([]);
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,

        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            did_you_work_more_than_one_employer_in_XX: 0,
            spouse_check_if_ITIN_to_be_renewed: 0,
            spouse_check_if_ITIN_to_be_applied: 0,
            spouse_itin_renewed: 0,
            ssn: "",
            spouse_ssn_or_itin: "",
        },
    });
    function convertDateToUserTimezone(givenDate: Date): Date {
        const userTimezoneOffset = new Date().getTimezoneOffset() / 60;

        // Remove timezone offset from given date
        const utcDate = new Date(
            givenDate.toLocaleString("en-US", { timeZone: "UTC" })
        );

        // Add user's timezone offset to utcDate
        const userDate = new Date(utcDate);
        userDate.setHours(userDate.getHours() + userTimezoneOffset);

        return userDate;
    }
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await BasicInfo_PersonalInfo();
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response.data.status == 1) {
                if (!isDisabled) {
                    console.log("3234324");
                    let currentYear =
                        response.data?.residency_details_for_states?.filter(
                            (item: any) => item.tax_year == SelectedYear
                        );

                    if (currentYear.length >= 1) {
                        // console.log(currentYear);
                        setCurrentYears(
                            currentYear?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,

                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "basic",
                            }))
                        );
                    }

                    let pastYear =
                        response.data?.residency_details_for_states?.filter(
                            (item: any) =>
                                item.tax_year == Number(SelectedYear - 1)
                        );
                    if (pastYear.length >= 1) {
                        setPastYears(
                            pastYear?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "basic",
                            }))
                        );
                    }
                    let OldDataNormal =
                        response.data?.residency_details_for_states
                            ?.filter(
                                (item: any) =>
                                    item.tax_year != Number(SelectedYear) - 1 &&
                                    item.tax_year != SelectedYear
                            )
                            ?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "basic",
                            }));
                    setOldData(OldDataNormal);
                    let currentYear_spouse =
                        response.data?.residency_details_for_states_spouse?.filter(
                            (item: any) => item.tax_year == SelectedYear
                        );
                    // console.log(currentYear);
                    if (currentYear_spouse.length >= 1) {
                        setCurrentYears_spouse(
                            currentYear_spouse?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "spouse",
                            }))
                        );
                    }

                    let pastYear_spose =
                        response.data?.residency_details_for_states_spouse?.filter(
                            (item: any) =>
                                item.tax_year == Number(SelectedYear) - 1
                        );
                    if (pastYear_spose.length >= 1) {
                        setPastYears_spouse(
                            pastYear_spose?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "spouse",
                            }))
                        );
                    }
                    let OldDataNormalSpouse =
                        response.data?.residency_details_for_states_spouse
                            ?.filter(
                                (item: any) =>
                                    item.tax_year != Number(SelectedYear) - 1 &&
                                    item.tax_year != SelectedYear
                            )
                            ?.map((item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "spouse",
                            }));
                    setOldDataSpouse(OldDataNormalSpouse);
                } else {
                    setCurrentYears_spouse(
                        response.data?.residency_details_for_states_spouse?.map(
                            (item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,
                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "spouse",
                            })
                        )
                    );
                    setCurrentYears(
                        response.data?.residency_details_for_states?.map(
                            (item: any) => ({
                                year: item.tax_year,
                                stateOfResidence: item?.states_resided,
                                From:
                                    item?.start_date &&
                                    item?.start_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.start_date
                                          )
                                        : null,
                                To:
                                    item?.end_date &&
                                    item?.end_date != "0000-00-00"
                                        ? convertDateToUserTimezone(
                                              item?.end_date
                                          )
                                        : null,
                                id: item.id,

                                AddStatus: 2,
                                residency_id: item.id,
                                type_of_residency_details:
                                    item.type_of_residency_details || "basic",
                            })
                        )
                    );
                    setPastYears([]);
                    setPastYears_spouse([]);
                }
                reset({
                    did_you_work_more_than_one_employer_in_XX:
                        response.data.basic_info
                            ?.did_you_work_more_than_one_employer_in_XX,
                    filing_status: response.data.basic_info?.filing_status,
                    first_name: response.data.basic_info?.first_name
                        ? response.data.basic_info?.first_name
                        : userDetails?.name,
                    citizenship: response.data.basic_info?.citizenship,
                    middle_name: response.data.basic_info?.middle_name,
                    last_name: response.data.basic_info?.last_name,
                    timezone: response.data.basic_info?.timezone
                        ? response.data.basic_info?.timezone
                        : userDetails?.timezone,
                    ssn: response.data.basic_info?.ssn,
                    dob:
                        response.data.basic_info?.dob &&
                        response.data.basic_info?.dob != "0000-00-00" &&
                        convertDateToUserTimezone(
                            response.data.basic_info?.dob
                        ),
                    date_of_marriage:
                        response.data.basic_info?.date_of_marriage &&
                        response.data.basic_info?.date_of_marriage !=
                            "0000-00-00" &&
                        convertDateToUserTimezone(
                            response.data.basic_info?.date_of_marriage
                        ),
                    type_of_visa: response.data.basic_info?.type_of_visa,
                    first_date_of_entry_in_US:
                        response.data.basic_info?.first_date_of_entry_in_US &&
                        response.data.basic_info?.first_date_of_entry_in_US !=
                            "0000-00-00" &&
                        response.data.basic_info?.first_date_of_entry_in_US &&
                        convertDateToUserTimezone(
                            response.data.basic_info?.first_date_of_entry_in_US
                        ),
                    occupation: response.data.basic_info?.occupation,
                    more_than_one_employer_work_status_comments:
                        response.data.basic_info
                            ?.more_than_one_employer_work_status_comments,
                    address: response.data.contact_details?.address,
                    city: response.data.contact_details?.city,
                    apt_no: response.data.contact_details?.apt_no,
                    state: response.data.contact_details?.state,
                    zip: response.data.contact_details?.zip,
                    country: response.data.contact_details?.country,
                    mobile_phone: response.data.contact_details?.mobile_phone,
                    alternate_phone:
                        response.data.contact_details?.alternate_phone,
                    india_number: response.data.contact_details?.india_number,
                    email: response.data.contact_details?.email,

                    spouse_first_name:
                        response.data?.spouse_details?.first_name,
                    spouse_last_name: response.data?.spouse_details?.last_name,
                    spouse_middle_name:
                        response.data?.spouse_details?.middle_name,
                    spouse_dob:
                        response.data?.spouse_details?.dob &&
                        response.data?.spouse_details?.dob != "0000-00-00" &&
                        convertDateToUserTimezone(
                            response.data?.spouse_details?.dob
                        ),
                    spouse_ssn_or_itin:
                        response.data?.spouse_details?.ssn_or_itin,
                    spouse_entry_date_into_US:
                        response.data?.spouse_details?.entry_date_into_US &&
                        response.data?.spouse_details?.entry_date_into_US !=
                            "0000-00-00" &&
                        convertDateToUserTimezone(
                            response.data?.spouse_details?.entry_date_into_US
                        ),
                    spouse_occupation:
                        response.data?.spouse_details?.occupation,
                    spouse_type_of_visa:
                        response.data?.spouse_details?.type_of_visa,
                    spouse_check_if_ITIN_to_be_applied:
                        response.data?.spouse_details
                            ?.check_if_ITIN_to_be_applied,
                    spouse_did_your_spouse_is_worked_in_XX:
                        response.data?.spouse_details
                            ?.did_your_spouse_is_worked_in_XX,
                    spouse_check_if_ITIN_to_be_renewed:
                        response.data?.spouse_details
                            ?.check_if_ITIN_to_be_renewed,
                    spouse_itin_renewed:
                        response.data?.spouse_details?.itin_renewed,

                    spouse_work_status_comments:
                        response.data?.spouse_details
                            ?.spouse_work_status_comments,
                    spouse_did_you_work_more_than_one_employer_in_XX:
                        response.data?.spouse_details
                            ?.did_you_work_more_than_one_employer_in_XX,
                    spouse_more_than_one_employer_work_status_comments:
                        response.data?.spouse_details
                            ?.more_than_one_employer_work_status_comments,
                });
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support 11team"
                );
                setLoading(false);
            }
        } catch (err: any) {
            console.log(err);
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        setValue("email", userDetails?.email);
        setValue("mobile_phone", userDetails?.phone);
    }, [userDetails]);
    useEffect(() => {
        GetDetails();
    }, []);
    const formData = watch();
    // console.log(formData);
    const addHandler = (type: string, type_of_residency_details: string) => {
        if (type == "current") {
            if (type_of_residency_details == "basic") {
                setCurrentYears((prev) => [
                    ...prev,
                    {
                        year: SelectedYear,
                        stateOfResidence: "",
                        From: null,
                        To: null,
                        id: uuidv4(),
                        AddStatus: 1,
                        residency_id: 0,
                        type_of_residency_details: type_of_residency_details,
                    },
                ]);
            } else {
                setCurrentYears_spouse((prev) => [
                    ...prev,
                    {
                        year: SelectedYear,
                        stateOfResidence: "",
                        From: null,
                        To: null,
                        id: uuidv4(),
                        AddStatus: 1,
                        residency_id: 0,
                        type_of_residency_details: type_of_residency_details,
                    },
                ]);
            }
        } else {
            if (type_of_residency_details == "basic") {
                setPastYears((prev) => [
                    ...prev,
                    {
                        year: Number(SelectedYear) - 1,
                        stateOfResidence: "",
                        From: null,
                        To: null,
                        id: uuidv4(),
                        AddStatus: 1,
                        residency_id: 0,
                        type_of_residency_details: type_of_residency_details,
                    },
                ]);
            } else {
                setPastYears_spouse((prev) => [
                    ...prev,
                    {
                        year: Number(SelectedYear) - 1,
                        stateOfResidence: "",
                        From: null,
                        To: null,
                        id: uuidv4(),
                        AddStatus: 1,
                        residency_id: 0,
                        type_of_residency_details: type_of_residency_details,
                    },
                ]);
            }
        }
    };
    // console.log(Past, Past_spouse);
    const removeHandler = (type: string, id: any, type_residency: string) => {
        if (type == "current") {
            if (type_residency == "basic") {
                if (
                    currentYears.filter(
                        (item) => item.AddStatus == 1 || item.AddStatus == 2
                    ).length > 1
                ) {
                    setCurrentYears((prev) =>
                        prev.map((item) =>
                            item.id != id ? item : { ...item, AddStatus: 0 }
                        )
                    );
                }
            } else {
                if (
                    currentYears_spouse.filter(
                        (item) => item.AddStatus == 1 || item.AddStatus == 2
                    ).length > 1
                ) {
                    setCurrentYears_spouse((prev) =>
                        prev.map((item) =>
                            item.id != id ? item : { ...item, AddStatus: 0 }
                        )
                    );
                }
            }
        } else if (type == "Past") {
            if (type_residency == "basic") {
                if (
                    Past.filter(
                        (item) => item.AddStatus == 1 || item.AddStatus == 2
                    ).length > 1
                ) {
                    setPastYears((prev) =>
                        prev.map((item) =>
                            item.id != id ? item : { ...item, AddStatus: 0 }
                        )
                    );
                }
            } else {
                if (
                    Past_spouse.filter(
                        (item) => item.AddStatus == 1 || item.AddStatus == 2
                    ).length > 1
                ) {
                    setPastYears_spouse((prev) =>
                        prev.map((item) =>
                            item.id != id ? item : { ...item, AddStatus: 0 }
                        )
                    );
                }
            }
        } else {
            if (type_residency == "basic") {
                setOldData((prev: any) =>
                    prev.map((item: any) =>
                        item.id != id ? item : { ...item, AddStatus: 0 }
                    )
                );
            } else {
                setOldDataSpouse((prev: any) =>
                    prev.map((item: any) =>
                        item.id != id ? item : { ...item, AddStatus: 0 }
                    )
                );
            }
        }
    };
    const changeHandler = (
        key: string,
        value: any,
        id: string,
        type: string,
        type_of_residency_details: string
    ) => {
        if (type == "current") {
            if (type_of_residency_details == "basic") {
                setCurrentYears((prev) =>
                    prev.map((item) =>
                        item.id === id ? { ...item, [key]: value } : item
                    )
                );
            } else {
                setCurrentYears_spouse((prev) =>
                    prev.map((item) =>
                        item.id === id ? { ...item, [key]: value } : item
                    )
                );
            }
        } else if (type == "Past") {
            if (type_of_residency_details == "basic") {
                setPastYears((prev) =>
                    prev.map((item) =>
                        item.id === id ? { ...item, [key]: value } : item
                    )
                );
            } else {
                setPastYears_spouse((prev) =>
                    prev.map((item) =>
                        item.id === id ? { ...item, [key]: value } : item
                    )
                );
            }
        } else {
            if (type_of_residency_details == "basic") {
                setOldData((prev: any) =>
                    prev.map((item: any) =>
                        item.id === id ? { ...item, [key]: value } : item
                    )
                );
            } else {
                setOldDataSpouse((prev: any) =>
                    prev.map((item: any) =>
                        item.id === id ? { ...item, [key]: value } : item
                    )
                );
            }
        }
    };
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (!isChecked) {
            return;
        }
        const currentDate = moment();
        const sixMonthsAgo = currentDate.subtract(6, "months");
        let body: any = [
            {
                Table: "basic_info",
                Data: {
                    did_you_work_more_than_one_employer_in_XX:
                        data.did_you_work_more_than_one_employer_in_XX,
                    filing_status: data.filing_status,
                    first_name: data.first_name,
                    middle_name: data.middle_name,
                    citizenship: data?.citizenship,
                    last_name: data.last_name,
                    timezone: data.timezone,
                    ssn: data.ssn,
                    dob: moment(data.dob).format("YYYY-MM-DD"),
                    date_of_marriage: moment(data.date_of_marriage).format(
                        "YYYY-MM-DD"
                    ),
                    type_of_visa: data.type_of_visa,
                    first_date_of_entry_in_US: moment(
                        data.first_date_of_entry_in_US
                    ).format("YYYY-MM-DD"),
                    occupation: data.occupation,
                    more_than_one_employer_work_status_comments:
                        data.more_than_one_employer_work_status_comments,
                },
            },
            {
                Table: "contact_details",
                Data: {
                    address: data.address,
                    city: data.city,
                    apt_no: data.apt_no,
                    state: data.state,
                    zip: data.zip,
                    country: data.country,
                    mobile_phone: userDetails.phone,
                    alternate_phone: data.alternate_phone,
                    india_number: data.india_number,
                    email: userDetails?.email,
                    timezone: data.timezone,
                },
            },

            {
                Table: "residency_details_for_states",
                Data: [
                    ...currentYears.map((item) => ({
                        tax_year: item.year,
                        states_resided: item.stateOfResidence,
                        start_date: moment(item.From).format("YYYY-MM-DD"),
                        end_date: moment(item.To).format("YYYY-MM-DD"),
                        AddStatus: item.AddStatus,
                        residency_id: item.residency_id,
                        type_of_residency_details: "basic",
                    })),
                    ...Past.map((item) => ({
                        tax_year: item.year,
                        states_resided: item.stateOfResidence,

                        start_date: moment(item.From).format("YYYY-MM-DD"),
                        end_date: moment(item.To).format("YYYY-MM-DD"),
                        AddStatus: item.AddStatus,
                        residency_id: item.residency_id,
                        type_of_residency_details: "basic",
                    })),
                    ...oldData.map((item: any) => ({
                        tax_year: item.year,
                        states_resided: item.stateOfResidence,

                        start_date: moment(item.From).format("YYYY-MM-DD"),
                        end_date: moment(item.To).format("YYYY-MM-DD"),
                        AddStatus: item.AddStatus,
                        residency_id: item.residency_id,
                        type_of_residency_details: "basic",
                    })),
                    ...currentYears_spouse.map((item) => ({
                        tax_year: item.year,
                        states_resided: item.stateOfResidence,

                        start_date: moment(item.From).format("YYYY-MM-DD"),
                        end_date: moment(item.To).format("YYYY-MM-DD"),
                        AddStatus: item.AddStatus,
                        residency_id: item.residency_id,
                        type_of_residency_details: "spouse",
                    })),
                    ...Past_spouse.map((item) => ({
                        tax_year: item.year,
                        states_resided: item.stateOfResidence,

                        start_date: moment(item.From).format("YYYY-MM-DD"),
                        end_date: moment(item.To).format("YYYY-MM-DD"),
                        AddStatus: item.AddStatus,
                        residency_id: item.residency_id,
                        type_of_residency_details: "spouse",
                    })),

                    ...oldDataSpouse.map((item: any) => ({
                        tax_year: item.year,
                        states_resided: item.stateOfResidence,

                        start_date: moment(item.From).format("YYYY-MM-DD"),
                        end_date: moment(item.To).format("YYYY-MM-DD"),
                        AddStatus: item.AddStatus,
                        residency_id: item.residency_id,
                        type_of_residency_details: "spouse",
                    })),
                ],
            },
        ];
        if (formData?.filing_status != "single") {
            body = [
                ...body,
                {
                    Table: "spouse_details",
                    Data: {
                        first_name: data?.spouse_first_name,
                        last_name: data?.spouse_last_name,
                        middle_name: data?.spouse_middle_name,
                        dob: moment(data?.spouse_dob).format("YYYY-MM-DD"),
                        ssn_or_itin: data?.spouse_ssn_or_itin,
                        entry_date_into_US: moment(
                            data?.spouse_entry_date_into_US
                        ).format("YYYY-MM-DD"),
                        occupation: data?.spouse_occupation,
                        type_of_visa: data?.spouse_type_of_visa,
                        check_if_ITIN_to_be_applied:
                            data?.spouse_check_if_ITIN_to_be_applied,
                        did_your_spouse_is_worked_in_XX:
                            data?.spouse_did_your_spouse_is_worked_in_XX,
                        check_if_ITIN_to_be_renewed:
                            data?.spouse_check_if_ITIN_to_be_renewed,
                        itin_renewed: data?.spouse_itin_renewed,
                        Is_living_more_than_6months:
                            data?.spouse_entry_date_into_US
                                ? moment(
                                      data?.spouse_entry_date_into_US
                                  ).isBefore(sixMonthsAgo)
                                    ? 1
                                    : 0
                                : "NA",
                        spouse_work_status_comments:
                            data?.spouse_work_status_comments,
                        did_you_work_more_than_one_employer_in_XX:
                            data?.spouse_did_you_work_more_than_one_employer_in_XX,
                        more_than_one_employer_work_status_comments:
                            data.spouse_more_than_one_employer_work_status_comments,
                    },
                },
            ];
        }

        setLoading(true);
        try {
            const response = await BasicInfo_PersonalInfo_ADD(body);
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessNotification("Personal info updated successfully");
            } else {
                showWarningAlert(
                    response?.data.Message || "Somethign went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    const handleRadioChange = (name: keyof Inputs, value: number) => {
        setValue(name, value);
        if (name === "spouse_itin_renewed") {
            setValue("spouse_check_if_ITIN_to_be_applied", 0);
            setValue("spouse_check_if_ITIN_to_be_renewed", 0);
        } else if (name === "spouse_check_if_ITIN_to_be_applied") {
            setValue("spouse_itin_renewed", 0);
            setValue("spouse_check_if_ITIN_to_be_renewed", 0);
        } else if (name === "spouse_check_if_ITIN_to_be_renewed") {
            setValue("spouse_itin_renewed", 0);
            setValue("spouse_check_if_ITIN_to_be_applied", 0);
        }
    };
    const formatSSN = (value: string) => {
        if (value) {
            const digits = value?.replace(/\D/g, "").slice(0, 9); // Get only numbers, max 9 digits
            let formatted = "";

            if (digits.length > 0) formatted += digits.slice(0, 3); // First 3 digits
            if (digits.length > 3) formatted += "-" + digits.slice(3, 5); // Next 2 digits
            if (digits.length > 5) formatted += "-" + digits.slice(5, 9); // Last 4 digits

            return formatted;
        }
    };
    const formatMobile = (value: string) => {
        if (value) {
            const digits = value?.replace(/\D/g, "").slice(0, 10); // Get only digits, max 10 digits
            let formatted = "";

            if (digits.length > 0) formatted += digits.slice(0, 3); // First 3 digits
            if (digits.length > 3) formatted += "-" + digits.slice(3, 6); // Next 3 digits
            if (digits.length > 6) formatted += "-" + digits.slice(6, 10); // Last 4 digits

            return formatted;
        }
    };
    return (
        <>
            <div
                className={`${Styleclasses["Container"]} ${Styleclasses["Container_personal"]}`}>
                {loading && <Load />}

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={Styleclasses["info"]}>
                        <h3>Personal Identity Information</h3>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Filing Status </label>
                            <select
                                className={
                                    errors?.filing_status &&
                                    Styleclasses["error-input"]
                                }
                                disabled={isDisabled}
                                id=""
                                {...register("filing_status", {
                                    required: true,
                                })}>
                                <option value="">Please select</option>
                                <option value="single">Single</option>
                                <option value="married">
                                    Married filing jointly
                                </option>
                                <option value="married_filing_seperately">
                                    Married filing seperately
                                </option>
                                <option value="head_household">
                                    Head of Household
                                </option>
                                <option value="divorce">Divorce</option>
                            </select>
                            {errors?.filing_status && (
                                <p>Filing Status is required</p>
                            )}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">First Name</label>
                            <input
                                disabled={isDisabled}
                                className={
                                    errors?.first_name &&
                                    Styleclasses["error-input"]
                                }
                                type="text"
                                placeholder="Enter your First Name"
                                {...register("first_name", {
                                    required: "First Name is requifred",
                                    pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    },
                                })}
                            />
                            {errors?.first_name && (
                                <p>{errors?.first_name?.message}</p>
                            )}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Middle Name</label>
                            <input
                                disabled={isDisabled}
                                type="text"
                                className={
                                    errors?.middle_name &&
                                    Styleclasses["error-input"]
                                }
                                placeholder="Enter your Middle Name"
                                {...register("middle_name", {
                                    required: false,
                                    pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    },
                                })}
                            />
                            {errors?.middle_name && (
                                <p>{errors?.middle_name?.message}</p>
                            )}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Last Name</label>
                            <input
                                disabled={isDisabled}
                                type="text"
                                className={
                                    errors?.last_name &&
                                    Styleclasses["error-input"]
                                }
                                placeholder="Enter your Last Name"
                                {...register("last_name", {
                                    required: "Last Name is required",
                                    pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    },
                                })}
                            />
                            {errors?.last_name && (
                                <p>{errors?.last_name?.message}</p>
                            )}
                        </div>

                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Occupation</label>
                            <input
                                disabled={isDisabled}
                                className={
                                    errors?.occupation &&
                                    Styleclasses["error-input"]
                                }
                                {...register("occupation", {
                                    required: false,
                                    /*   pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    }, */
                                })}
                                type="text"
                                placeholder="Enter your Occupation"
                            />
                            {errors.occupation && (
                                <p>{errors?.occupation.message}</p>
                            )}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Citizenship</label>
                            <input
                                disabled={isDisabled}
                                className={
                                    errors?.citizenship &&
                                    Styleclasses["error-input"]
                                }
                                {...register("citizenship", {
                                    required: false,
                                })}
                                type="text"
                                placeholder="Enter citizenship"
                            />
                            {errors.citizenship && (
                                <p>{errors?.citizenship?.message}</p>
                            )}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Email</label>
                            <input
                                type="email"
                                disabled
                                placeholder="Enter your Email"
                                {...register("email", { required: false })}
                            />
                            {errors?.email && <p>{errors?.email?.message}</p>}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Timezone</label>
                            <select
                                disabled={isDisabled}
                                className={
                                    errors?.timezone &&
                                    Styleclasses["error-input"]
                                }
                                {...register("timezone", { required: true })}>
                                <option value="">Please select</option>
                                <option value="CST">
                                    Central Standard Time(CST)
                                </option>
                                <option value="EST">
                                    Eastern Standard Time(EST)
                                </option>
                                <option value="MST">
                                    Mountain Standard Time(MST)
                                </option>
                                <option value="PST">
                                    Pacific Standard Time(PST)
                                </option>
                                <option value="IST">
                                    Indian Standard Time(IST)
                                </option>
                            </select>
                            {errors.timezone && <p>Timezone is required</p>}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">SSN</label>
                            {/* <input disabled={isDisabled}
                            
                            type="number"
                            {...register("ssn", { required: false })}
                            /> */}

                            <Controller
                                name="ssn"
                                control={control}
                                defaultValue=""
                                rules={{
                                    required: false,
                                    pattern: {
                                        value: /^\d{3}-\d{2}-\d{4}$/, // Validate format XXX-XX-XXXX
                                        message:
                                            "Invalid format. Use XXX-XX-XXXX for SSN",
                                    },
                                }}
                                render={({
                                    field: { onChange, onBlur, value, ref },
                                    fieldState: { error },
                                }) => (
                                    <>
                                        <input
                                            disabled={isDisabled}
                                            ref={ref}
                                            value={formatSSN(value)} // Format value for display
                                            onChange={(e) => {
                                                const formattedValue: any =
                                                    formatSSN(e.target.value);
                                                const cursorPosition =
                                                    e.target.selectionStart ??
                                                    0;
                                                onChange(formattedValue);
                                                setTimeout(() => {
                                                    const inputElement =
                                                        e.target;
                                                    // Adjust the cursor position after formatting
                                                    let newCursorPosition =
                                                        cursorPosition;

                                                    // Handle cursor positioning when hyphens are added or removed
                                                    // The cursor moves to the right after each character typed, accounting for hyphens

                                                    if (
                                                        formattedValue &&
                                                        formattedValue[
                                                            cursorPosition - 1
                                                        ] === "-" &&
                                                        !formattedValue[
                                                            cursorPosition + 1
                                                        ] &&
                                                        formattedValue.length >
                                                            formData.ssn
                                                                ?.length &&
                                                        cursorPosition > 1
                                                    ) {
                                                        newCursorPosition++; // If cursor was on a hyphen, move it right
                                                    }
                                                    inputElement.setSelectionRange(
                                                        newCursorPosition,
                                                        newCursorPosition
                                                    ); // Set cursor next to typed character
                                                }, 0);
                                            }}
                                            onBlur={onBlur}
                                            className={
                                                error ? "error-input" : ""
                                            }
                                            placeholder="SSN/ITIN (XXX-XX-XXXX)"
                                        />
                                        {error && (
                                            <p className="error-message">
                                                {error.message}
                                            </p>
                                        )}
                                    </>
                                )}
                            />
                        </div>
                        <div className={Styleclasses["form-date"]}>
                            <label htmlFor="">Date of birth</label>
                            <Controller
                                disabled={isDisabled}
                                control={control}
                                name="dob"
                                render={({ field }) => (
                                    <DatePicker
                                        yearPlaceholder="YYYY"
                                        monthPlaceholder="MM"
                                        dayPlaceholder="DD"
                                        className={
                                            Styleclasses["date-picker-custom"]
                                        }
                                        {...field}
                                        onKeyDown={(e) => e.preventDefault()}
                                        disabled={field.disabled}
                                        clearIcon={false}
                                        format="MM/dd/yyyy"
                                        calendarIcon={<span>📅</span>}
                                    />
                                )}
                            />

                            {errors?.dob && (
                                <p className="error-message">
                                    Date of birth is required
                                </p>
                            )}
                        </div>
                        <div className={Styleclasses["form-date"]}>
                            <label htmlFor="">Anniversary</label>
                            <Controller
                                disabled={isDisabled}
                                control={control}
                                name="date_of_marriage"
                                render={({ field }) => (
                                    <DatePicker
                                        yearPlaceholder="YYYY"
                                        monthPlaceholder="MM"
                                        dayPlaceholder="DD"
                                        className={
                                            Styleclasses["date-picker-custom"]
                                        }
                                        {...field}
                                        onKeyDown={(e) => e.preventDefault()}
                                        disabled={field.disabled}
                                        clearIcon={false}
                                        format="MM/dd/yyyy"
                                        calendarIcon={<span>📅</span>}
                                    />
                                )}
                            />
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Visa Type</label>
                            <select
                                disabled={isDisabled}
                                className={
                                    errors?.type_of_visa &&
                                    Styleclasses["error-input"]
                                }
                                id=""
                                {...register("type_of_visa", {
                                    required: false,
                                })}>
                                <option value="">Please Select</option>
                                <option value="F1">F1</option>
                                <option value="F2">F2</option>
                                <option value="H1">H1</option>
                                <option value="H4">H4</option>
                                <option value="L1">L1</option>
                                <option value="L2">L2</option>
                                <option value="B1">B1</option>
                                <option value="B2">B2</option>
                                <option value="J1">J1</option>
                                <option value="J2">J2</option>
                                <option value="us_citizen">U.S Citizen</option>
                                <option value="green_card">Green Card</option>
                            </select>

                            {errors?.type_of_visa && (
                                <p> Visa Type is required</p>
                            )}
                        </div>
                        <div className={Styleclasses["form-date"]}>
                            <label htmlFor="">First Entry</label>
                            <Controller
                                disabled={isDisabled}
                                control={control}
                                name="first_date_of_entry_in_US"
                                render={({ field }) => (
                                    <DatePicker
                                        yearPlaceholder="YYYY"
                                        monthPlaceholder="MM"
                                        dayPlaceholder="DD"
                                        className={
                                            Styleclasses["date-picker-custom"]
                                        }
                                        {...field}
                                        onKeyDown={(e) => e.preventDefault()}
                                        disabled={field.disabled}
                                        clearIcon={false}
                                        format="MM/dd/yyyy"
                                        calendarIcon={<span>📅</span>}
                                    />
                                )}
                            />

                            {errors?.first_date_of_entry_in_US && (
                                <p> Entry is required</p>
                            )}
                        </div>
                        <div className={Styleclasses["form-control_checkbox"]}>
                            <label htmlFor="">
                                Did you work for more than one employee? If yes
                                please specify it.
                            </label>
                            <label className="toggle">
                                <input
                                    disabled={isDisabled}
                                    className={Styleclasses["toggle-checkbox"]}
                                    type="checkbox"
                                    {...register(
                                        "did_you_work_more_than_one_employer_in_XX",
                                        {
                                            required: false,
                                            onChange: (e) =>
                                                setValue(
                                                    "did_you_work_more_than_one_employer_in_XX",
                                                    e.target.checked ? 1 : 0
                                                ),
                                        }
                                    )}
                                    checked={
                                        formData.did_you_work_more_than_one_employer_in_XX ===
                                        1
                                    }
                                />
                                <div
                                    className={
                                        Styleclasses["toggle-switch"]
                                    }></div>
                                {/*  <span className={Styles["toggle-label"]}>
                                Bluetooth
                            </span> */}
                            </label>
                        </div>
                        {formData.did_you_work_more_than_one_employer_in_XX ===
                            1 && (
                            <div
                                className={Styleclasses["form-control"]}
                                style={{ gridColumn: "1/-1" }}>
                                <textarea
                                    placeholder="Provide Details"
                                    {...register(
                                        "more_than_one_employer_work_status_comments"
                                    )}
                                />
                                {errors?.more_than_one_employer_work_status_comments && (
                                    <p> Comments is required</p>
                                )}
                            </div>
                        )}
                    </div>

                    <div
                        className={`${Styleclasses["info"]} ${Styleclasses["info_contact"]}`}>
                        <h3>Contact Information</h3>
                        <label htmlFor="">Phone Number</label>
                        <div className={Styleclasses["form-control"]}>
                            <div>
                                <h3>+1</h3>
                                <Controller
                                    name="mobile_phone"
                                    control={control}
                                    defaultValue=""
                                    /* rules={{
                                        pattern: {
                                            value: /^\d{3}-\d{3}-\d{4}$/, // Validate format XXX-XXX-XXXX
                                            message:
                                                "Invalid format. Use XXX-XXX-XXXX for mobile number",
                                        },
                                    }} */
                                    render={({
                                        field: { onChange, onBlur, value, ref },
                                        fieldState: { error },
                                    }) => (
                                        <>
                                            <input
                                                disabled
                                                ref={ref}
                                                value={formatMobile(value)} // Format value for display
                                                style={{
                                                    // textIndent: "2.3rem",
                                                    width: "100%",
                                                }}
                                                onChange={(e) => {
                                                    const formattedValue: any =
                                                        formatMobile(
                                                            e.target.value
                                                        );
                                                    const cursorPosition =
                                                        e.target
                                                            .selectionStart ??
                                                        0;
                                                    onChange(formattedValue);
                                                    setTimeout(() => {
                                                        const inputElement =
                                                            e.target;
                                                        // Adjust the cursor position after formatting
                                                        let newCursorPosition =
                                                            cursorPosition;

                                                        // Handle cursor positioning when hyphens are added or removed
                                                        // The cursor moves to the right after each character typed, accounting for hyphens

                                                        if (
                                                            formattedValue &&
                                                            formattedValue[
                                                                cursorPosition -
                                                                    1
                                                            ] === "-" &&
                                                            !formattedValue[
                                                                cursorPosition +
                                                                    1
                                                            ] &&
                                                            formattedValue.length >
                                                                formData
                                                                    .mobile_phone
                                                                    ?.length &&
                                                            cursorPosition > 1
                                                        ) {
                                                            newCursorPosition++; // If cursor was on a hyphen, move it right
                                                        }
                                                        inputElement.setSelectionRange(
                                                            newCursorPosition,
                                                            newCursorPosition
                                                        ); // Set cursor next to typed character
                                                    }, 0);
                                                }}
                                                onBlur={onBlur}
                                                className={
                                                    error ? "error-input" : ""
                                                }
                                                placeholder="Mobile Number (XXX-XXX-XXXX)"
                                            />
                                            {error && (
                                                <p className="error-message">
                                                    {error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            {/* <label htmlFor="">Alternate phone</label> */}

                            <div>
                                <h3>+1</h3>
                                <Controller
                                    name="alternate_phone"
                                    control={control}
                                    defaultValue=""
                                    rules={{
                                        pattern: {
                                            value: /^\d{3}-\d{3}-\d{4}$/, // Validate format XXX-XXX-XXXX
                                            message:
                                                "Invalid format. Use XXX-XXX-XXXX for mobile number",
                                        },
                                    }}
                                    render={({
                                        field: { onChange, onBlur, value, ref },
                                        fieldState: { error },
                                    }) => (
                                        <>
                                            <input
                                                disabled={isDisabled}
                                                style={{
                                                    width: "100%",
                                                }}
                                                ref={ref}
                                                value={formatMobile(value)} // Format value for display
                                                onChange={(e) => {
                                                    const formattedValue: any =
                                                        formatMobile(
                                                            e.target.value
                                                        );
                                                    const cursorPosition =
                                                        e.target
                                                            .selectionStart ??
                                                        0;
                                                    onChange(formattedValue);
                                                    setTimeout(() => {
                                                        const inputElement =
                                                            e.target;
                                                        // Adjust the cursor position after formatting
                                                        let newCursorPosition =
                                                            cursorPosition;

                                                        // Handle cursor positioning when hyphens are added or removed
                                                        // The cursor moves to the right after each character typed, accounting for hyphens

                                                        if (
                                                            formattedValue &&
                                                            formattedValue[
                                                                cursorPosition -
                                                                    1
                                                            ] === "-" &&
                                                            !formattedValue[
                                                                cursorPosition +
                                                                    1
                                                            ] &&
                                                            formattedValue.length >
                                                                formData
                                                                    .alternate_phone
                                                                    ?.length &&
                                                            cursorPosition > 1
                                                        ) {
                                                            newCursorPosition++; // If cursor was on a hyphen, move it right
                                                        }
                                                        inputElement.setSelectionRange(
                                                            newCursorPosition,
                                                            newCursorPosition
                                                        ); // Set cursor next to typed character
                                                    }, 0);
                                                }}
                                                onBlur={onBlur}
                                                className={
                                                    error ? "error-input" : ""
                                                }
                                                placeholder="Mobile Number (XXX-XXX-XXXX)"
                                            />
                                            {error && (
                                                <p className="error-message">
                                                    {error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            {/* <label htmlFor="">Indian phone</label> */}
                            <div>
                                <h3>+91</h3>
                                <Controller
                                    name="india_number"
                                    control={control}
                                    defaultValue=""
                                    rules={{
                                        pattern: {
                                            value: /^\d{3}-\d{3}-\d{4}$/, // Validate format XXX-XXX-XXXX
                                            message:
                                                "Invalid format. Use XXX-XXX-XXXX for mobile number",
                                        },
                                    }}
                                    render={({
                                        field: { onChange, onBlur, value, ref },
                                        fieldState: { error },
                                    }) => (
                                        <>
                                            <input
                                                disabled={isDisabled}
                                                style={{
                                                    textIndent: "2.3rem",
                                                    width: "100%",
                                                }}
                                                ref={ref}
                                                value={formatMobile(value)} // Format value for display
                                                onChange={(e) => {
                                                    const formattedValue: any =
                                                        formatMobile(
                                                            e.target.value
                                                        );
                                                    const cursorPosition =
                                                        e.target
                                                            .selectionStart ??
                                                        0;
                                                    onChange(formattedValue);
                                                    setTimeout(() => {
                                                        const inputElement =
                                                            e.target;
                                                        // Adjust the cursor position after formatting
                                                        let newCursorPosition =
                                                            cursorPosition;

                                                        // Handle cursor positioning when hyphens are added or removed
                                                        // The cursor moves to the right after each character typed, accounting for hyphens

                                                        if (
                                                            formattedValue &&
                                                            formattedValue[
                                                                cursorPosition -
                                                                    1
                                                            ] === "-" &&
                                                            !formattedValue[
                                                                cursorPosition +
                                                                    1
                                                            ] &&
                                                            formattedValue.length >
                                                                formData
                                                                    .india_number
                                                                    ?.length &&
                                                            cursorPosition > 1
                                                        ) {
                                                            newCursorPosition++; // If cursor was on a hyphen, move it right
                                                        }
                                                        inputElement.setSelectionRange(
                                                            newCursorPosition,
                                                            newCursorPosition
                                                        ); // Set cursor next to typed character
                                                    }, 0);
                                                }}
                                                onBlur={onBlur}
                                                className={
                                                    error ? "error-input" : ""
                                                }
                                                placeholder="Mobile Number (XXX-XXX-XXXX)"
                                            />
                                            {error && (
                                                <p className="error-message">
                                                    {error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <label htmlFor="">Mailing Address</label>
                        <div
                            className={`${Styleclasses["form-control"]} ${Styleclasses["form-control_address"]}`}>
                            <input
                                disabled={isDisabled}
                                className={
                                    errors.address &&
                                    Styleclasses["error-input"]
                                }
                                type="text"
                                placeholder="Mailing address"
                                {...register("address", { required: false })}
                            />
                            {errors?.address && <p>Address is required</p>}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            {/* <label htmlFor="">Apartment</label> */}
                            <input
                                disabled={isDisabled}
                                type="text"
                                placeholder="Apartment"
                                className={
                                    errors.apt_no && Styleclasses["error-input"]
                                }
                                {...register("apt_no", { required: false })}
                            />
                            {errors?.apt_no && <p>Apartment is required</p>}
                        </div>
                        <div></div>
                        <div className={Styleclasses["form-control"]}>
                            {/* <label htmlFor="">City</label> */}
                            <input
                                disabled={isDisabled}
                                type="text"
                                className={
                                    errors.city && Styleclasses["error-input"]
                                }
                                {...register("city", { required: false })}
                                placeholder="Enter City name"
                            />
                            {errors?.city && <p>City is required</p>}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            {/* <label htmlFor="">State</label> */}
                            <input
                                disabled={isDisabled}
                                type="text"
                                placeholder="Enter State"
                                {...register("state", {
                                    required: false,
                                    pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    },
                                })}
                                className={
                                    errors.state && Styleclasses["error-input"]
                                }
                            />
                            {errors?.state && <p>{errors?.state?.message}</p>}
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            {/* <label htmlFor="">Country</label> */}
                            <input
                                disabled={isDisabled}
                                type="text"
                                placeholder="Enter Country"
                                {...register("country", {
                                    required: false,
                                    pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    },
                                })}
                                className={
                                    errors.country &&
                                    Styleclasses["error-input"]
                                }
                            />
                            {errors?.state && <p>{errors?.country?.message}</p>}
                        </div>
                        <div></div>
                        <div className={Styleclasses["form-control"]}>
                            {/* <label htmlFor="">Zipcode</label> */}
                            <input
                                disabled={isDisabled}
                                type="text"
                                placeholder="Enter Zipcode "
                                className={
                                    errors.zip && Styleclasses["error-input"]
                                }
                                {...register("zip", { required: false })}
                            />
                            {errors?.zip && <p>Zipcode is required</p>}
                        </div>
                    </div>
                    <div className={Styleclasses["info-tax"]}>
                        <h3>
                            Residential Address(es) during tax year{" "}
                            <span>
                                [Please list out all the address(es) you stayed
                                at during the tax year]
                            </span>
                        </h3>
                        <div className={Styleclasses["table-wrapper"]}>
                            <table className={Styleclasses["tax-years"]}>
                                <thead className={Styleclasses["tax-heading"]}>
                                    <tr>
                                        <th>Tax Year</th>
                                        <th>State of Residence</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Option</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentYears
                                        .filter(
                                            (item) =>
                                                item.AddStatus == 1 ||
                                                item.AddStatus == 2
                                        )

                                        ?.map((item) => (
                                            <tr>
                                                <td>{item.year}</td>
                                                <td
                                                    className={
                                                        Styleclasses[
                                                            "stateResidence"
                                                        ]
                                                    }>
                                                    <input
                                                        disabled={isDisabled}
                                                        onChange={(e) =>
                                                            changeHandler(
                                                                "stateOfResidence",
                                                                e.target.value,
                                                                item.id,
                                                                "current",
                                                                "basic"
                                                            )
                                                        }
                                                        type="text"
                                                        placeholder="State of residence"
                                                        value={
                                                            item.stateOfResidence
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        yearPlaceholder="YYYY"
                                                        monthPlaceholder="MM"
                                                        dayPlaceholder="DD"
                                                        className={
                                                            Styleclasses[
                                                                "date-picker-custom"
                                                            ]
                                                        }
                                                        onKeyDown={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        clearIcon={false}
                                                        disabled={isDisabled}
                                                        value={item.From}
                                                        onChange={(date) =>
                                                            changeHandler(
                                                                "From",
                                                                date,
                                                                item.id,
                                                                "current",
                                                                "basic"
                                                            )
                                                        }
                                                        calendarIcon={
                                                            <span>📅</span>
                                                        }
                                                        format="MM/dd/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        clearIcon={false}
                                                        yearPlaceholder="YYYY"
                                                        monthPlaceholder="MM"
                                                        dayPlaceholder="DD"
                                                        className={
                                                            Styleclasses[
                                                                "date-picker-custom"
                                                            ]
                                                        }
                                                        onKeyDown={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        calendarIcon={
                                                            <span>📅</span>
                                                        }
                                                        disabled={isDisabled}
                                                        value={item.To}
                                                        onChange={(date) =>
                                                            changeHandler(
                                                                "To",
                                                                date,
                                                                item.id,
                                                                "current",
                                                                "basic"
                                                            )
                                                        }
                                                        format="MM/dd/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <div
                                                        className={
                                                            Styleclasses[
                                                                "action-btns"
                                                            ]
                                                        }>
                                                        <button
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            type="button"
                                                            onClick={() =>
                                                                addHandler(
                                                                    "current",
                                                                    "basic"
                                                                )
                                                            }>
                                                            +
                                                        </button>
                                                        <button
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            type="button"
                                                            onClick={() => {
                                                                removeHandler(
                                                                    "current",
                                                                    item.id,
                                                                    "basic"
                                                                );
                                                            }}>
                                                            -
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    {Past?.filter(
                                        (item) =>
                                            item.AddStatus == 1 ||
                                            item.AddStatus == 2
                                    )?.map((item) => (
                                        <tr>
                                            <td>{item.year}</td>
                                            <td
                                                className={
                                                    Styleclasses[
                                                        "stateResidence"
                                                    ]
                                                }>
                                                <input
                                                    disabled={isDisabled}
                                                    onChange={(e) =>
                                                        changeHandler(
                                                            "stateOfResidence",
                                                            e.target.value,
                                                            item.id,
                                                            "Past",
                                                            "basic"
                                                        )
                                                    }
                                                    type="text"
                                                    placeholder="State of residence"
                                                    value={
                                                        item.stateOfResidence
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <DatePicker
                                                    clearIcon={false}
                                                    yearPlaceholder="YYYY"
                                                    monthPlaceholder="MM"
                                                    dayPlaceholder="DD"
                                                    className={
                                                        Styleclasses[
                                                            "date-picker-custom"
                                                        ]
                                                    }
                                                    calendarIcon={
                                                        <span>📅</span>
                                                    }
                                                    disabled={isDisabled}
                                                    value={item.From}
                                                    onChange={(date) =>
                                                        changeHandler(
                                                            "From",
                                                            date,
                                                            item.id,
                                                            "Past",
                                                            "basic"
                                                        )
                                                    }
                                                    onKeyDown={(e) =>
                                                        e.preventDefault()
                                                    }
                                                    format="MM/dd/yyyy"
                                                />
                                            </td>
                                            <td>
                                                <DatePicker
                                                    clearIcon={false}
                                                    yearPlaceholder="YYYY"
                                                    monthPlaceholder="MM"
                                                    dayPlaceholder="DD"
                                                    className={
                                                        Styleclasses[
                                                            "date-picker-custom"
                                                        ]
                                                    }
                                                    calendarIcon={
                                                        <span>📅</span>
                                                    }
                                                    disabled={isDisabled}
                                                    value={item.To}
                                                    onChange={(date) =>
                                                        changeHandler(
                                                            "To",
                                                            date,
                                                            item.id,
                                                            "Past",
                                                            "basic"
                                                        )
                                                    }
                                                    onKeyDown={(e) =>
                                                        e.preventDefault()
                                                    }
                                                    format="MM/dd/yyyy"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    className={
                                                        Styleclasses[
                                                            "action-btns"
                                                        ]
                                                    }>
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            addHandler(
                                                                "Past",
                                                                "basic"
                                                            )
                                                        }>
                                                        +
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            removeHandler(
                                                                "Past",
                                                                item.id,
                                                                "basic"
                                                            );
                                                        }}>
                                                        -
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {oldData
                                        .filter(
                                            (item: any) =>
                                                item.AddStatus == 1 ||
                                                item.AddStatus == 2
                                        )

                                        ?.map((item: any) => (
                                            <tr>
                                                <td>{item.year}</td>
                                                <td
                                                    className={
                                                        Styleclasses[
                                                            "stateResidence"
                                                        ]
                                                    }>
                                                    <input
                                                        disabled={isDisabled}
                                                        onChange={(e) =>
                                                            changeHandler(
                                                                "stateOfResidence",
                                                                e.target.value,
                                                                item.id,
                                                                "old",
                                                                "basic"
                                                            )
                                                        }
                                                        type="text"
                                                        placeholder="State of residence"
                                                        value={
                                                            item.stateOfResidence
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        yearPlaceholder="YYYY"
                                                        monthPlaceholder="MM"
                                                        dayPlaceholder="DD"
                                                        className={
                                                            Styleclasses[
                                                                "date-picker-custom"
                                                            ]
                                                        }
                                                        onKeyDown={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        clearIcon={false}
                                                        disabled={isDisabled}
                                                        value={item.From}
                                                        onChange={(date) =>
                                                            changeHandler(
                                                                "From",
                                                                date,
                                                                item.id,
                                                                "old",
                                                                "basic"
                                                            )
                                                        }
                                                        calendarIcon={
                                                            <span>📅</span>
                                                        }
                                                        format="MM/dd/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        clearIcon={false}
                                                        yearPlaceholder="YYYY"
                                                        monthPlaceholder="MM"
                                                        dayPlaceholder="DD"
                                                        className={
                                                            Styleclasses[
                                                                "date-picker-custom"
                                                            ]
                                                        }
                                                        onKeyDown={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        calendarIcon={
                                                            <span>📅</span>
                                                        }
                                                        disabled={isDisabled}
                                                        value={item.To}
                                                        onChange={(date) =>
                                                            changeHandler(
                                                                "To",
                                                                date,
                                                                item.id,
                                                                "old",
                                                                "basic"
                                                            )
                                                        }
                                                        format="MM/dd/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <div
                                                        className={
                                                            Styleclasses[
                                                                "action-btns"
                                                            ]
                                                        }>
                                                        <button
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            type="button"
                                                            onClick={() => {
                                                                removeHandler(
                                                                    "old",
                                                                    item.id,
                                                                    "basic"
                                                                );
                                                            }}>
                                                            -
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {formData?.filing_status != "single" && (
                        <div className={Styleclasses["info"]}>
                            <h3>Spouse's Identity Information</h3>
                            <div className={Styleclasses["form-control"]}>
                                <label htmlFor=""> First Name</label>
                                <input
                                    disabled={isDisabled}
                                    className={
                                        errors.spouse_first_name &&
                                        Styleclasses["error-input"]
                                    }
                                    type="text"
                                    placeholder="Enter First name"
                                    {...register("spouse_first_name", {
                                        required: false,
                                        pattern: {
                                            value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                            message:
                                                "Only alphabetic characters and spaces are allowed",
                                        },
                                    })}
                                />
                                {errors?.spouse_first_name && (
                                    <p>{errors?.spouse_first_name?.message}</p>
                                )}
                            </div>
                            <div className={Styleclasses["form-control"]}>
                                <label htmlFor=""> Middle Name</label>
                                <input
                                    disabled={isDisabled}
                                    className={
                                        errors.spouse_middle_name &&
                                        Styleclasses["error-input"]
                                    }
                                    type="text"
                                    placeholder="Enter Middle name"
                                    {...register("spouse_middle_name", {
                                        required: false,
                                        pattern: {
                                            value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                            message:
                                                "Only alphabetic characters and spaces are allowed",
                                        },
                                    })}
                                />
                                {errors?.spouse_middle_name && (
                                    <p>{errors?.spouse_last_name?.message}</p>
                                )}
                            </div>
                            <div className={Styleclasses["form-control"]}>
                                <label htmlFor=""> Last Name</label>
                                <input
                                    disabled={isDisabled}
                                    className={
                                        errors.spouse_last_name &&
                                        Styleclasses["error-input"]
                                    }
                                    type="text"
                                    placeholder="Enter Last name"
                                    {...register("spouse_last_name", {
                                        required: false,
                                        pattern: {
                                            value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                            message:
                                                "Only alphabetic characters and spaces are allowed",
                                        },
                                    })}
                                />
                                {errors?.spouse_last_name && (
                                    <p>{errors?.spouse_last_name?.message}</p>
                                )}
                            </div>
                            <div className={Styleclasses["form-date"]}>
                                <label htmlFor="">Date of Birth</label>
                                <Controller
                                    disabled={isDisabled}
                                    control={control}
                                    name="spouse_dob"
                                    render={({ field }) => (
                                        <DatePicker
                                            yearPlaceholder="YYYY"
                                            monthPlaceholder="MM"
                                            dayPlaceholder="DD"
                                            className={
                                                Styleclasses[
                                                    "date-picker-custom"
                                                ]
                                            }
                                            {...field}
                                            onKeyDown={(e) =>
                                                e.preventDefault()
                                            }
                                            disabled={field.disabled}
                                            clearIcon={false}
                                            format="MM/dd/yyyy"
                                            calendarIcon={<span>📅</span>}
                                        />
                                    )}
                                />
                                {errors?.spouse_dob && <p>Enter DOB</p>}
                            </div>
                            <div className={Styleclasses["form-control"]}>
                                <label htmlFor="">SSN/ITIN</label>
                                {/*   <input disabled={isDisabled}
                                
                                type="text"
                                placeholder="SSN/ITIN"
                                {...register("spouse_ssn_or_itin", {
                                    required: false,
                                })}
                            /> */}

                                <Controller
                                    name="spouse_ssn_or_itin"
                                    control={control}
                                    defaultValue=""
                                    rules={{
                                        required: false,
                                        pattern: {
                                            value: /^\d{3}-\d{2}-\d{4}$/, // Validate format XXX-XX-XXXX
                                            message:
                                                "Invalid format. Use XXX-XX-XXXX for SSN",
                                        },
                                    }}
                                    render={({
                                        field: { onChange, onBlur, value, ref },
                                        fieldState: { error },
                                    }) => (
                                        <>
                                            <input
                                                disabled={isDisabled}
                                                ref={ref}
                                                value={formatSSN(value)} // Format value for display
                                                onChange={(e) => {
                                                    const formattedValue: any =
                                                        formatSSN(
                                                            e.target.value
                                                        );
                                                    const cursorPosition =
                                                        e.target
                                                            .selectionStart ??
                                                        0;
                                                    onChange(formattedValue);
                                                    setTimeout(() => {
                                                        const inputElement =
                                                            e.target;
                                                        // Adjust the cursor position after formatting
                                                        let newCursorPosition =
                                                            cursorPosition;

                                                        // Handle cursor positioning when hyphens are added or removed
                                                        // The cursor moves to the right after each character typed, accounting for hyphens

                                                        if (
                                                            formattedValue &&
                                                            formattedValue[
                                                                cursorPosition -
                                                                    1
                                                            ] === "-" &&
                                                            !formattedValue[
                                                                cursorPosition +
                                                                    1
                                                            ] &&
                                                            formattedValue.length >
                                                                formData
                                                                    .spouse_ssn_or_itin
                                                                    ?.length &&
                                                            cursorPosition > 1
                                                        ) {
                                                            newCursorPosition++; // If cursor was on a hyphen, move it right
                                                        }
                                                        inputElement.setSelectionRange(
                                                            newCursorPosition,
                                                            newCursorPosition
                                                        ); // Set cursor next to typed character
                                                    }, 0);
                                                }}
                                                onBlur={onBlur}
                                                className={
                                                    error ? "error-input" : ""
                                                }
                                                placeholder="SSN/ITIN (XXX-XX-XXXX)"
                                            />
                                            {error && (
                                                <p className="error-message">
                                                    {error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                            <div className={Styleclasses["form-control"]}>
                                <label htmlFor="">Visa type</label>
                                <select
                                    disabled={isDisabled}
                                    className={
                                        errors?.spouse_type_of_visa &&
                                        Styleclasses["error-input"]
                                    }
                                    id=""
                                    {...register("spouse_type_of_visa", {
                                        required: false,
                                    })}>
                                    <option value="">Please Select</option>
                                    <option value="F1">F1</option>
                                    <option value="F2">F2</option>
                                    <option value="H1">H1</option>
                                    <option value="H4">H4</option>
                                    <option value="L1">L1</option>
                                    <option value="L2">L2</option>
                                    <option value="B1">B1</option>
                                    <option value="B2">B2</option>
                                    <option value="J1">J1</option>
                                    <option value="J2">J2</option>
                                    <option value="us_citizen">
                                        U.S Citizen
                                    </option>
                                    <option value="green_card">
                                        Green Card
                                    </option>
                                </select>
                                {errors?.spouse_type_of_visa && (
                                    <p>Visa Type is required</p>
                                )}
                            </div>
                            <div className={Styleclasses["form-date"]}>
                                <label htmlFor="">First Entry(if any)</label>
                                <Controller
                                    disabled={isDisabled}
                                    control={control}
                                    name="spouse_entry_date_into_US"
                                    render={({ field }) => (
                                        <DatePicker
                                            yearPlaceholder="YYYY"
                                            monthPlaceholder="MM"
                                            dayPlaceholder="DD"
                                            className={
                                                Styleclasses[
                                                    "date-picker-custom"
                                                ]
                                            }
                                            {...field}
                                            onKeyDown={(e) =>
                                                e.preventDefault()
                                            }
                                            disabled={field.disabled}
                                            clearIcon={false}
                                            format="MM/dd/yyyy"
                                            calendarIcon={<span>📅</span>}
                                        />
                                    )}
                                />

                                {errors?.spouse_entry_date_into_US && (
                                    <p>
                                        {
                                            errors.spouse_entry_date_into_US
                                                ?.message
                                        }
                                    </p>
                                )}
                            </div>
                            <div className={Styleclasses["form-control"]}>
                                <label htmlFor="">Occupation</label>
                                <input
                                    disabled={isDisabled}
                                    className={
                                        errors.spouse_occupation &&
                                        Styleclasses["error-input"]
                                    }
                                    type="text"
                                    {...register("spouse_occupation", {
                                        required: false,
                                    })}
                                />
                                {errors?.spouse_occupation && (
                                    <p>Occupication is required</p>
                                )}
                            </div>

                            <div
                                className={Styleclasses["form-control_radio"]}
                                style={{ gridColumn: "1/-1" }}>
                                <label htmlFor="">IRS Status</label>
                                <div className={Styleclasses["notification"]}>
                                    <div>
                                        <input
                                            disabled={isDisabled}
                                            type="radio"
                                            name="Notification"
                                            value="SSN"
                                        />
                                        <label htmlFor="javascript">SSN</label>
                                    </div>
                                    <div>
                                        <input
                                            disabled={isDisabled}
                                            type="radio"
                                            name="Notification"
                                            value="ITIN"
                                            checked={
                                                formData.spouse_itin_renewed ==
                                                1
                                            }
                                            onChange={(e) =>
                                                handleRadioChange(
                                                    "spouse_itin_renewed",
                                                    e.target.checked ? 1 : 0
                                                )
                                            }
                                        />
                                        <label htmlFor="ITIN">ITIN</label>
                                    </div>
                                    <div>
                                        <input
                                            disabled={isDisabled}
                                            type="radio"
                                            name="Notification"
                                            value="Applying ITIN"
                                            checked={
                                                formData.spouse_check_if_ITIN_to_be_applied ==
                                                1
                                            }
                                            onChange={(e) =>
                                                handleRadioChange(
                                                    "spouse_check_if_ITIN_to_be_applied",
                                                    e.target.checked ? 1 : 0
                                                )
                                            }
                                        />
                                        <label htmlFor="ITIN">
                                            Applying ITIN
                                        </label>
                                    </div>
                                    <div>
                                        <input
                                            disabled={isDisabled}
                                            type="radio"
                                            name="Notification"
                                            value="Renewing ITIN"
                                            checked={
                                                formData?.spouse_check_if_ITIN_to_be_renewed ==
                                                1
                                            }
                                            onChange={(e) =>
                                                handleRadioChange(
                                                    "spouse_check_if_ITIN_to_be_renewed",
                                                    e.target.checked ? 1 : 0
                                                )
                                            }
                                        />
                                        <label htmlFor="ITIN">
                                            Renewing ITIN
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={
                                    Styleclasses["form-control_checkbox"]
                                }>
                                <label htmlFor="">
                                    Did you Spouse work in {SelectedYear}? If
                                    yes please specify it.
                                </label>
                                <label className="toggle">
                                    <input
                                        disabled={isDisabled}
                                        className={
                                            Styleclasses["toggle-checkbox"]
                                        }
                                        type="checkbox"
                                        {...register(
                                            "spouse_did_your_spouse_is_worked_in_XX",
                                            {
                                                required: false,
                                                onChange: (e) =>
                                                    setValue(
                                                        "spouse_did_your_spouse_is_worked_in_XX",
                                                        e.target.checked ? 1 : 0
                                                    ),
                                            }
                                        )}
                                        checked={
                                            formData.spouse_did_your_spouse_is_worked_in_XX ===
                                            1
                                        }
                                    />
                                    <div
                                        className={
                                            Styleclasses["toggle-switch"]
                                        }></div>
                                    {/*  <span className={Styles["toggle-label"]}>
                                Bluetooth
                            </span> */}
                                </label>
                            </div>
                            {formData.spouse_did_your_spouse_is_worked_in_XX ===
                                1 && (
                                <div
                                    className={Styleclasses["form-control"]}
                                    style={{ gridColumn: "1/-1" }}>
                                    <textarea
                                        placeholder="Provide Details"
                                        {...register(
                                            "spouse_work_status_comments"
                                        )}
                                    />
                                    {errors?.spouse_work_status_comments && (
                                        <p> Comments is required</p>
                                    )}
                                </div>
                            )}
                            <div
                                className={
                                    Styleclasses["form-control_checkbox"]
                                }>
                                <label htmlFor="">
                                    Did you Spouse work for more than one
                                    employee in {SelectedYear}? If yes please
                                    specify it.
                                </label>
                                <label className="toggle">
                                    <input
                                        disabled={isDisabled}
                                        className={
                                            Styleclasses["toggle-checkbox"]
                                        }
                                        type="checkbox"
                                        {...register(
                                            "spouse_did_you_work_more_than_one_employer_in_XX",
                                            {
                                                required: false,
                                                onChange: (e) =>
                                                    setValue(
                                                        "spouse_did_you_work_more_than_one_employer_in_XX",
                                                        e.target.checked ? 1 : 0
                                                    ),
                                            }
                                        )}
                                        checked={
                                            formData.spouse_did_you_work_more_than_one_employer_in_XX ===
                                            1
                                        }
                                    />
                                    <div
                                        className={
                                            Styleclasses["toggle-switch"]
                                        }></div>
                                    {/*  <span className={Styles["toggle-label"]}>
                                Bluetooth
                            </span> */}
                                </label>
                            </div>
                            {formData.spouse_did_you_work_more_than_one_employer_in_XX ===
                                1 && (
                                <div
                                    className={Styleclasses["form-control"]}
                                    style={{ gridColumn: "1/-1" }}>
                                    <textarea
                                        placeholder="Provide Details"
                                        {...register(
                                            "spouse_more_than_one_employer_work_status_comments"
                                        )}
                                    />
                                    {errors?.spouse_more_than_one_employer_work_status_comments && (
                                        <p> Comments is required</p>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    <div className={Styleclasses["info-tax"]}>
                        {formData?.filing_status != "single" && (
                            <h3>
                                Residential Address(es) during tax year{" "}
                                <span>
                                    [Please list out all the address(es) your
                                    Spouse stayed at during the tax year]
                                </span>
                            </h3>
                        )}
                        {formData?.filing_status != "single" && (
                            <div className={Styleclasses["table-wrapper"]}>
                                <table className={Styleclasses["tax-years"]}>
                                    <thead
                                        className={Styleclasses["tax-heading"]}>
                                        <tr>
                                            <th>Tax Year</th>
                                            <th>State of Residence</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Option</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentYears_spouse
                                            .filter(
                                                (item) =>
                                                    item.AddStatus == 1 ||
                                                    item.AddStatus == 2
                                            )

                                            ?.map((item) => (
                                                <tr>
                                                    <td>{item.year}</td>
                                                    <td
                                                        className={
                                                            Styleclasses[
                                                                "stateResidence"
                                                            ]
                                                        }>
                                                        <input
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            onChange={(e) =>
                                                                changeHandler(
                                                                    "stateOfResidence",
                                                                    e.target
                                                                        .value,
                                                                    item.id,
                                                                    "current",
                                                                    "spouse"
                                                                )
                                                            }
                                                            type="text"
                                                            placeholder="State of residence"
                                                            value={
                                                                item.stateOfResidence
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <DatePicker
                                                            yearPlaceholder="YYYY"
                                                            monthPlaceholder="MM"
                                                            dayPlaceholder="DD"
                                                            className={
                                                                Styleclasses[
                                                                    "date-picker-custom"
                                                                ]
                                                            }
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            calendarIcon={
                                                                <span>📅</span>
                                                            }
                                                            clearIcon={false}
                                                            value={item.From}
                                                            onChange={(date) =>
                                                                changeHandler(
                                                                    "From",
                                                                    date,
                                                                    item.id,
                                                                    "current",
                                                                    "spouse"
                                                                )
                                                            }
                                                            onKeyDown={(e) =>
                                                                e.preventDefault()
                                                            }
                                                            format="MM/dd/yyyy"
                                                        />
                                                    </td>
                                                    <td>
                                                        <DatePicker
                                                            clearIcon={false}
                                                            yearPlaceholder="YYYY"
                                                            monthPlaceholder="MM"
                                                            dayPlaceholder="DD"
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            className={
                                                                Styleclasses[
                                                                    "date-picker-custom"
                                                                ]
                                                            }
                                                            calendarIcon={
                                                                <span>📅</span>
                                                            }
                                                            value={item.To}
                                                            onChange={(date) =>
                                                                changeHandler(
                                                                    "To",
                                                                    date,
                                                                    item.id,
                                                                    "current",
                                                                    "spouse"
                                                                )
                                                            }
                                                            onKeyDown={(e) =>
                                                                e.preventDefault()
                                                            }
                                                            format="MM/dd/yyyy"
                                                        />
                                                    </td>
                                                    <td>
                                                        <div
                                                            className={
                                                                Styleclasses[
                                                                    "action-btns"
                                                                ]
                                                            }>
                                                            <button
                                                                disabled={
                                                                    isDisabled
                                                                }
                                                                type="button"
                                                                onClick={() =>
                                                                    addHandler(
                                                                        "current",
                                                                        "spouse"
                                                                    )
                                                                }>
                                                                +
                                                            </button>
                                                            <button
                                                                disabled={
                                                                    isDisabled
                                                                }
                                                                type="button"
                                                                onClick={() => {
                                                                    removeHandler(
                                                                        "current",
                                                                        item.id,
                                                                        "spouse"
                                                                    );
                                                                }}>
                                                                -
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        {Past_spouse?.filter(
                                            (item) =>
                                                item.AddStatus == 1 ||
                                                item.AddStatus == 2
                                        )?.map((item) => (
                                            <tr>
                                                <td>{item.year}</td>
                                                <td
                                                    className={
                                                        Styleclasses[
                                                            "stateResidence"
                                                        ]
                                                    }>
                                                    <input
                                                        disabled={isDisabled}
                                                        onChange={(e) =>
                                                            changeHandler(
                                                                "stateOfResidence",
                                                                e.target.value,
                                                                item.id,
                                                                "Past",
                                                                "spouse"
                                                            )
                                                        }
                                                        type="text"
                                                        placeholder="State of residence"
                                                        value={
                                                            item.stateOfResidence
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        clearIcon={false}
                                                        yearPlaceholder="YYYY"
                                                        monthPlaceholder="MM"
                                                        dayPlaceholder="DD"
                                                        className={
                                                            Styleclasses[
                                                                "date-picker-custom"
                                                            ]
                                                        }
                                                        calendarIcon={
                                                            <span>📅</span>
                                                        }
                                                        onKeyDown={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        disabled={isDisabled}
                                                        value={item.From}
                                                        onChange={(date) =>
                                                            changeHandler(
                                                                "From",
                                                                date,
                                                                item.id,
                                                                "Past",
                                                                "spouse"
                                                            )
                                                        }
                                                        format="MM/dd/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        clearIcon={false}
                                                        yearPlaceholder="YYYY"
                                                        monthPlaceholder="MM"
                                                        dayPlaceholder="DD"
                                                        className={
                                                            Styleclasses[
                                                                "date-picker-custom"
                                                            ]
                                                        }
                                                        calendarIcon={
                                                            <span>📅</span>
                                                        }
                                                        disabled={isDisabled}
                                                        value={item.To}
                                                        onChange={(date) =>
                                                            changeHandler(
                                                                "To",
                                                                date,
                                                                item.id,
                                                                "Past",
                                                                "spouse"
                                                            )
                                                        }
                                                        onKeyDown={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        format="MM/dd/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <div
                                                        className={
                                                            Styleclasses[
                                                                "action-btns"
                                                            ]
                                                        }>
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                addHandler(
                                                                    "Past",
                                                                    "spouse"
                                                                )
                                                            }>
                                                            +
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                removeHandler(
                                                                    "Past",
                                                                    item.id,
                                                                    "spouse"
                                                                );
                                                            }}>
                                                            -
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        {oldDataSpouse
                                            ?.filter(
                                                (item: any) =>
                                                    item.AddStatus == 1 ||
                                                    item.AddStatus == 2
                                            )
                                            ?.map((item: any) => (
                                                <tr>
                                                    <td>{item.year}</td>
                                                    <td
                                                        className={
                                                            Styleclasses[
                                                                "stateResidence"
                                                            ]
                                                        }>
                                                        <input
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            onChange={(e) =>
                                                                changeHandler(
                                                                    "stateOfResidence",
                                                                    e.target
                                                                        .value,
                                                                    item.id,
                                                                    "old",
                                                                    "spouse"
                                                                )
                                                            }
                                                            type="text"
                                                            placeholder="State of residence"
                                                            value={
                                                                item.stateOfResidence
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <DatePicker
                                                            clearIcon={false}
                                                            yearPlaceholder="YYYY"
                                                            monthPlaceholder="MM"
                                                            dayPlaceholder="DD"
                                                            className={
                                                                Styleclasses[
                                                                    "date-picker-custom"
                                                                ]
                                                            }
                                                            calendarIcon={
                                                                <span>📅</span>
                                                            }
                                                            onKeyDown={(e) =>
                                                                e.preventDefault()
                                                            }
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            value={item.To}
                                                            onChange={(date) =>
                                                                changeHandler(
                                                                    "From",
                                                                    date,
                                                                    item.id,
                                                                    "old",
                                                                    "spouse"
                                                                )
                                                            }
                                                            format="MM/dd/yyyy"
                                                        />
                                                    </td>
                                                    <td>
                                                        <DatePicker
                                                            clearIcon={false}
                                                            yearPlaceholder="YYYY"
                                                            monthPlaceholder="MM"
                                                            dayPlaceholder="DD"
                                                            className={
                                                                Styleclasses[
                                                                    "date-picker-custom"
                                                                ]
                                                            }
                                                            calendarIcon={
                                                                <span>📅</span>
                                                            }
                                                            disabled={
                                                                isDisabled
                                                            }
                                                            value={item.To}
                                                            onChange={(date) =>
                                                                changeHandler(
                                                                    "To",
                                                                    date,
                                                                    item.id,
                                                                    "old",
                                                                    "spouse"
                                                                )
                                                            }
                                                            onKeyDown={(e) =>
                                                                e.preventDefault()
                                                            }
                                                            format="MM/dd/yyyy"
                                                        />
                                                    </td>
                                                    <td>
                                                        <div
                                                            className={
                                                                Styleclasses[
                                                                    "action-btns"
                                                                ]
                                                            }>
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    removeHandler(
                                                                        "old",
                                                                        item.id,
                                                                        "spouse"
                                                                    );
                                                                }}>
                                                                -
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <div className={Styleclasses["declaration"]}>
                            <h3>
                                <input
                                    disabled={isDisabled}
                                    type="checkbox"
                                    id="pushNotification"
                                    onChange={(e) =>
                                        setIschecked(e.target.checked)
                                    }
                                />
                                <label
                                    htmlFor="pushNotification"
                                    className={Styleclasses["checkbox-label"]}>
                                    I declare that the information in this
                                    application is true and correct
                                </label>
                            </h3>
                            <div className={Styleclasses["save-btns"]}>
                                <button disabled={isDisabled || !isChecked}>
                                    Save
                                </button>

                                {/* <button type="button">Reset</button> */}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default PersonalInfo;
